import Vue from 'vue';
import VueRouter from 'vue-router';
import layout from '../src/views/layout/index.vue'; // 布局组件

Vue.use(VueRouter);

const routes = [{
		path: '/login',
		component: (resolve) => require(['../src/views/login/index.vue'], resolve),
	},
	{
		path: '',
		component: layout,
		redirect: '',
		children: [{
			path: '/home',
			component: (resolve) => require(['../src/views/Home.vue'], resolve),
			meta: {
				title: '系统首页',
				requireAuth: true,
			},
		}, ],
	},
	{
		path: "/",
		component: layout,
		meta: {
			title: '图片库'
		},
		name: 'mat_class',
		redirect: 'mat_class',
		children: [{
				path: '/mat_class',
				name: 'mat_class',
				component: (resolve) =>
					require(['../src/views/imgLibrary/index.vue'], resolve),
				meta: {
					title: '一级分类',
					requireAuth: true,
				},
			},
			{
				path: '/mat_class2',
				name: 'mat_class2',
				component: (resolve) =>
					require(['../src/views/imgLibrary/index2.vue'], resolve),
				meta: {
					title: '二级分类',
					requireAuth: true,
				},
			}, {
				path: '/mat_class3',
				name: 'mat_class3',
				component: (resolve) =>
					require(['../src/views/imgLibrary/index3.vue'], resolve),
				meta: {
					title: '三级分类',
					requireAuth: true,
				},
			}, {
				path: '/mat_class4',
				name: 'mat_class4',
				component: (resolve) =>
					require(['../src/views/imgLibrary/index4.vue'], resolve),
				meta: {
					title: '素材',
					requireAuth: true,
				},
			}
		]
	},
	//数据应用
	{
		path: '/',
		component: layout,
		meta: {
			title: '数据应用',
		},
		name: 'dataApp',
		redirect: '/dataApp',
		children: [{
				path: '/dataApp',
				name: 'dataApp',
				component: (resolve) =>
					require(['../src/views/dataApp/index.vue'], resolve),
				meta: {
					title: '应用列表',
					requireAuth: true,
				},
			},
			{
				path: '/course',
				name: 'course',
				component: (resolve) =>
					require(['../src/views/dataApp/course.vue'], resolve),
				meta: {
					title: '推荐课程',
					requireAuth: true,
				},
			},
			{
				path: '/fuwu',
				name: 'fuwu',
				component: (resolve) =>
					require(['../src/views/dataApp/fuwu.vue'], resolve),
				meta: {
					title: '服务',
					requireAuth: true,
				},
			},
		],
	},
	//节日关怀
	{
		path: '/',
		component: layout,
		meta: {
			title: '节日关怀',
		},
		name: 'holidayList',
		redirect: '/holidayList',
		children: [{
			path: '/holidayList',
			name: 'holidayList',
			component: (resolve) =>
				require(['../src/views/holidayList/index.vue'], resolve),
			meta: {
				title: '节日列表',
				requireAuth: true,
			},
		}, ],
	},
	// 四阵地
	{
		path: '/',
		component: layout,
		meta: {
			title: '四阵地',
		},
		name: 'trategyPlan',
		redirect: '/trategyPlan',
		children: [{
				path: '/trategyPlan',
				name: 'trategyPlan',
				component: (resolve) =>
					require(['../src/views/fourPositions/trategyPlan.vue'], resolve),
				meta: {
					title: '策略方案',
					requireAuth: true,
				},
			},
			{
				path: '/strDeta',
				name: 'strDeta',
				component: (resolve) =>
					require(['../src/views/fourPositions/strDeta.vue'], resolve),
				meta: {
					title: '策略明细',
					requireAuth: true,
				},
			},
			{
				path: '/scenario',
				name: 'scenario',
				component: (resolve) =>
					require(['../src/views/fourPositions/scenario.vue'], resolve),
				meta: {
					title: '剧本',
					requireAuth: true,
				},
			},
			{
				path: '/scenarioDetails',
				name: 'scenarioDetails',
				component: (resolve) =>
					require(['../src/views/fourPositions/scenarioDetails.vue'], resolve),
				meta: {
					title: '剧本详情',
					requireAuth: true,
				},
			},
			{
				path: '/action',
				name: 'action',
				component: (resolve) =>
					require(['../src/views/fourPositions/action.vue'], resolve),
				meta: {
					title: '动作类型',
					requireAuth: true,
				},
			},
			{
				path: '/strategy',
				name: 'strategy',
				component: (resolve) =>
					require(['../src/views/fourPositions/strategy.vue'], resolve),
				meta: {
					title: '策略类型',
					requireAuth: true,
				},
			},
		],
	},
	//训练营
	{
		path: '/',
		component: layout,
		meta: {
			title: '训练营',
		},
		name: 'Clinic',
		redirect: '/Clinic',
		children: [{
				path: '/Clinic',
				name: 'Clinic',
				component: (resolve) =>
					require(['../src/views/Clinic/index.vue'], resolve),
				meta: {
					title: '训练营列表',
					requireAuth: true,
				},
			},
			{
				path: '/par',
				name: 'par',
				component: (resolve) =>
					require(['../src/views/Clinic/par.vue'], resolve),
				meta: {
					title: '参与人员',
					requireAuth: true,
				},
			},
			{
				path: '/per',
				name: 'per',
				component: (resolve) =>
					require(['../src/views/Clinic/per.vue'], resolve),
				meta: {
					title: '队员心得',
					requireAuth: true,
				},
			},
			{
				path: '/cliDetails',
				name: 'cliDetails',
				component: (resolve) =>
					require(['../src/views/Clinic/cliDetails.vue'], resolve),
				meta: {
					title: '新增/编辑',
					requireAuth: true,
				},
			},
		],
	},
	//销售计划
	{
		path: '/',
		component: layout,
		meta: {
			title: '销售计划',
		},
		name: 'plans',
		redirect: '/plans',
		children: [{
			path: '/plans',
			name: 'plans',
			component: (resolve) =>
				require(['../src/views/plans/index.vue'], resolve),
			meta: {
				title: '销售计划列表',
				requireAuth: true,
			},
		}, ],
	},
	//标签
	{
		path: '/',
		component: layout,
		meta: {
			title: '标签',
		},
		name: 'agency',
		redirect: '/agency',
		children: [{
				path: '/agency',
				name: 'agency',
				component: (resolve) =>
					require(['../src/views/Label/agency/index.vue'], resolve),
				meta: {
					title: '代理人设标签',
					requireAuth: true,
				},
			},
			{
				path: '/userLabel',
				name: 'userLabel',
				component: (resolve) =>
					require(['../src/views/Label/userLabel/index.vue'], resolve),
				meta: {
					title: '用户标签',
					requireAuth: true,
				},
			},
			{
				path: '/laberName',
				name: 'laberName',
				component: (resolve) =>
					require(['../src/views/Label/userLabel/laberName.vue'], resolve),
				meta: {
					title: '标签名称',
					requireAuth: true,
				},
			},
			{
				path: '/labelValue',
				name: 'labelValue',
				component: (resolve) =>
					require(['../src/views/Label/userLabel/labelValue.vue'], resolve),
				meta: {
					title: '标签值',
					requireAuth: true,
				},
			},
		],
	},
	//节日素材
	{
		path: '/',
		component: layout,
		meta: {
			title: '知识库',
		},
		name: 'holiday',
		redirect: '/holiday',
		children: [{
				path: '/holiday',
				name: 'holiday',
				component: (resolve) =>
					require(['../src/views/repository/holiday/index.vue'], resolve),
				meta: {
					title: '每日素材',
					requireAuth: true,
				},
			},
			{
				path: '/details',
				name: 'details',
				component: (resolve) =>
					require(['../src/views/repository/holiday/details.vue'], resolve),
				meta: {
					title: '素材详情',
					requireAuth: true,
				},
			},
			{
				path: '/bossShare',
				name: 'bossShare',
				component: (resolve) =>
					require(['../src/views/repository/holiday2/index.vue'], resolve),
				meta: {
					title: '科普类分享',
					requireAuth: true,
				},
			},
			{
				path: '/shareDetails',
				name: 'shareDetails',
				component: (resolve) =>
					require(['../src/views/repository/holiday2/details.vue'], resolve),
				meta: {
					title: '分享详情',
					requireAuth: true,
				},
			},
			{
				path: '/Circle',
				name: 'Circle',
				component: (resolve) =>
					require(['../src/views/repository/Circle/index.vue'], resolve),
				meta: {
					title: '圈文素材',
					requireAuth: true,
				},
			},
			{
				path: '/category',
				name: 'category',
				component: (resolve) =>
					require(['../src/views/repository/category/index.vue'], resolve),
				meta: {
					title: '品类知识库',
					requireAuth: true,
				},
			},
			{
				path: '/catDetails',
				name: 'catDetails',
				component: (resolve) =>
					require(['../src/views/repository/category/catDetails.vue'], resolve),
				meta: {
					title: '品类知识',
					requireAuth: true,
				},
			},
			{
				path: '/catStyle',
				name: 'catStyle',
				component: (resolve) =>
					require(['../src/views/repository/catStyle/index.vue'], resolve),
				meta: {
					title: '品类款式',
					requireAuth: true,
				},
			},
			{
				path: '/catStyleDet',
				name: 'catStyleDet',
				component: (resolve) =>
					require([
						'../src/views/repository/catStyle/catStyleDet.vue',
					], resolve),
				meta: {
					title: '品类款式详情',
					requireAuth: true,
				},
			},
			{
				path: '/catMan',
				name: 'catMan',
				component: (resolve) =>
					require(['../src/views/repository/catMan/index.vue'], resolve),
				meta: {
					title: '品类管理',
					requireAuth: true,
				},
			},
			{
				path: '/matType',
				name: 'matType',
				component: (resolve) =>
					require(['../src/views/repository/matType/index.vue'], resolve),
				meta: {
					title: '素材类型',
					requireAuth: true,
				},
			},
			{
				path: '/appSce',
				name: 'appSce',
				component: (resolve) =>
					require(['../src/views/repository/appSce/index.vue'], resolve),
				meta: {
					title: '应用场景',
					requireAuth: true,
				},
			},
			{
				path: '/groupLibrary',
				name: 'groupLibrary',
				component: (resolve) =>
					require(['../src/views/repository/groupLibrary/index.vue'], resolve),
				meta: {
					title: '圈文素材目录',
					requireAuth: true,
				},
			}
		],
	},
	//课件管理
	{
		path: '/',
		component: layout,
		meta: {
			title: '课件管理',
		},
		name: 'coursewareList',
		redirect: '/coursewareList',
		children: [{
				path: '/coursewareList',
				name: 'coursewareList',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coursewareList/index.vue',
					], resolve),
				meta: {
					title: '课件列表',
					requireAuth: true,
				},
			},
			{
				path: '/viewCourseware',
				name: 'viewCourseware',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coursewareList/viewCourseware.vue',
					], resolve),
				meta: {
					title: '查看课件',
					requireAuth: true,
				},
			},
			{
				path: '/addKeCheng',
				name: 'addKeCheng',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coursewareList/addKeCheng.vue',
					], resolve),
				meta: {
					title: '新增课程',
					requireAuth: true,
				},
			},
			{
				path: '/viewDate',
				name: 'viewDate',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coursewareList/viewDate.vue',
					], resolve),
				meta: {
					title: '数据查看',
					requireAuth: true,
				},
			},
			{
				path: '/addCoursewareList',
				name: 'addCoursewareList',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/addCoursewareList/index.vue',
					], resolve),
				meta: {
					title: '新增课件',
					requireAuth: true,
				},
			},
			{
				path: '/next',
				name: 'next',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/addCoursewareList/next.vue',
					], resolve),
				meta: {
					title: '下一步',
					requireAuth: true,
				},
			},
			{
				path: '/coursewareSort',
				name: 'coursewareSort',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coursewareSort/index.vue',
					], resolve),
				meta: {
					title: '课件类别',
					requireAuth: true,
				},
			},
			{
				path: '/coursewareDirection',
				name: 'coursewareDirection',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coursewareDirection/index.vue',
					], resolve),
				meta: {
					title: '课件方向',
					requireAuth: true,
				},
			},
			{
				path: '/coursewareOrder',
				name: 'coursewareOrder',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coursewareOrder/index.vue',
					], resolve),
				meta: {
					title: '课件订单',
					requireAuth: true,
				},
			},
			{
				path: '/coursewareOrderdteails',
				name: 'coursewareOrderdteails',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coursewareOrder/coursewareOrderdteails.vue',
					], resolve),
				meta: {
					title: '订单详情',
					requireAuth: true,
				},
			},
			{
				path: '/coupons',
				name: 'coupons',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coupons/index.vue',
					], resolve),
				meta: {
					title: '优惠券',
					requireAuth: true,
				},
			},
			{
				path: '/seeUse',
				name: 'seeUse',
				component: (resolve) =>
					require([
						'../src/views/coursewareManagement/coupons/seeUse.vue',
					], resolve),
				meta: {
					title: '查看使用',
					requireAuth: true,
				},
			},
		],
	},
	//站点管理
	{
		path: '/',
		component: layout,
		meta: {
			title: '站点管理',
		},
		name: 'zone',
		redirect: '/zone',
		children: [{
				path: '/zone',
				name: 'zone',
				component: (resolve) =>
					require(['../src/views/siteManagement/zone/index.vue'], resolve),
				meta: {
					title: '专区管理',
					requireAuth: true,
				},
			},
			{
				path: '/zoneManagement',
				name: 'zoneManagement',
				component: (resolve) =>
					require([
						'../src/views/siteManagement/zone/zoneManagement.vue',
					], resolve),
				meta: {
					title: '专区课程',
					requireAuth: true,
				},
			},
			{
				path: '/add',
				name: 'add',
				component: (resolve) =>
					require(['../src/views/siteManagement/zone/add.vue'], resolve),
				meta: {
					title: '添加课程',
					requireAuth: true,
				},
			},
			{
				path: '/article',
				name: 'article',
				component: (resolve) =>
					require(['../src/views/siteManagement/article/index.vue'], resolve),
				meta: {
					title: '文章管理',
					requireAuth: true,
				},
			},
			{
				path: '/editor',
				name: 'editor',
				component: (resolve) =>
					require(['../src/views/siteManagement/article/editor.vue'], resolve),
				meta: {
					title: '编辑文章',
					requireAuth: true,
				},
			},
			{
				path: '/notice',
				name: 'notice',
				component: (resolve) =>
					require(['../src/views/siteManagement/notice/index.vue'], resolve),
				meta: {
					title: '公告管理',
					requireAuth: true,
				},
			},
			{
				path: '/addnotice',
				name: 'addnotice',
				component: (resolve) =>
					require([
						'../src/views/siteManagement/notice/addnotice.vue',
					], resolve),
				meta: {
					title: '编辑公告',
					requireAuth: true,
				},
			},
			{
				path: '/banner',
				name: 'banner',
				component: (resolve) =>
					require(['../src/views/siteManagement/banner/index.vue'], resolve),
				meta: {
					title: '轮播图',
					requireAuth: true,
				},
			},
		],
	},
	//随堂检测
	{
		path: '/',
		component: layout,
		meta: {
			title: '随堂检测',
		},
		name: 'test',
		redirect: '/test',
		children: [{
				path: '/test',
				name: 'test',
				component: (resolve) =>
					require(['../src/views/Suitang/test/index.vue'], resolve),
				meta: {
					title: '随堂考试',
					requireAuth: true,
				},
			},
			{
				path: '/addClrTest',
				name: 'addClrTest',
				component: (resolve) =>
					require(['../src/views/Suitang/test/addClrTest.vue'], resolve),
				meta: {
					title: '添加试卷',
					requireAuth: true,
				},
			},
			{
				path: '/seeStudents',
				name: 'seeStudents',
				component: (resolve) =>
					require(['../src/views/Suitang/test/seeStudents.vue'], resolve),
				meta: {
					title: '查看学生',
					requireAuth: true,
				},
			},
			{
				path: '/seeDetail',
				name: 'seeDetail',
				component: (resolve) =>
					require(['../src/views/Suitang/test/seeDetail.vue'], resolve),
				meta: {
					title: '答案明细',
					requireAuth: true,
				},
			},
			{
				path: '/homework',
				name: 'homework',
				component: (resolve) =>
					require(['../src/views/Suitang/homework/index.vue'], resolve),
				meta: {
					title: '随堂作业',
					requireAuth: true,
				},
			},
			{
				path: '/create',
				name: 'create',
				component: (resolve) =>
					require(['../src/views/Suitang/homework/create.vue'], resolve),
				meta: {
					title: '创建作业',
					requireAuth: true,
				},
			},
			{
				path: '/check',
				name: 'check',
				component: (resolve) =>
					require(['../src/views/Suitang/homework/check.vue'], resolve),
				meta: {
					title: '批改作业',
					requireAuth: true,
				},
			},
			{
				path: '/workDetails',
				name: 'workDetails',
				component: (resolve) =>
					require(['../src/views/Suitang/homework/workDetails.vue'], resolve),
				meta: {
					title: '作业详情',
					requireAuth: true,
				},
			},
		],
	},
	// 课程考核路由
	{
		path: '/',
		component: layout,
		meta: {
			title: '课考模块',
		},
		name: 'class',
		redirect: '/class',
		children: [{
				path: '/class',
				name: 'class',
				component: (resolve) =>
					require(['../src/views/clr/class/class.vue'], resolve),
				meta: {
					title: '课程管理',
					requireAuth: true,
				},
			},
			{
				path: '/exam',
				name: 'exam',
				component: (resolve) =>
					require(['../src/views/clr/exam/exam.vue'], resolve),
				meta: {
					title: '考试管理',
					requireAuth: true,
				},
			},
			{
				path: '/batch',
				name: 'batch',
				component: (resolve) =>
					require(['../src/views/clr/batch/batch.vue'], resolve),
				meta: {
					title: '阅卷批考',
					requireAuth: true,
				},
			},
			{
				path: '/knowledge',
				name: 'knowledge',
				component: (resolve) =>
					require(['../src/views/clr/knowledge/knowledge.vue'], resolve),
				meta: {
					title: '知识点管理',
					requireAuth: true,
				},
			},
		],
	},
	// 素材库路由
	{
		path: '/',
		component: layout,
		meta: {
			title: '素材模块',
		},
		name: 'mat',
		redirect: '/scattered',
		children: [{
				path: '/scattered',
				name: 'scattered',
				component: (resolve) =>
					require(['../src/views/mat/scattered/index.vue'], resolve),
				meta: {
					title: '圈文素材管理',
					requireAuth: true,
				},
			},
			{
				path: '/matset',
				name: 'matset',
				component: (resolve) =>
					require(['../src/views/mat/set/set.vue'], resolve),
				meta: {
					title: '镶嵌素材管理',
					requireAuth: true,
				},
			},
			{
				path: '/beading',
				name: 'beading',
				component: (resolve) =>
					require(['../src/views/mat/beading/beading.vue'], resolve),
				meta: {
					title: '串珠素材管理',
					requireAuth: true,
				},
			},
			{
				path: '/loosebeads',
				name: 'loosebeads',
				component: (resolve) =>
					require(['../src/views/mat/loosebeads/loosebeads.vue'], resolve),
				meta: {
					title: '散珠素材管理',
					requireAuth: true,
				},
			},
			{
				path: '/activity',
				name: 'activity',
				component: (resolve) =>
					require(['../src/views/mat/activity/activity.vue'], resolve),
				meta: {
					title: '定制故事',
					requireAuth: true,
				},
			},
			{
				path: '/customized',
				name: 'customized',
				component: (resolve) =>
					require(['../src/views/mat/customized/index.vue'], resolve),
				meta: {
					title: '定制故事',
					requireAuth: true,
				},
			},
			{
				path: '/carving',
				name: 'carving',
				component: (resolve) =>
					require(['../src/views/mat/carving/index.vue'], resolve),
				meta: {
					title: '雕刻设计素材库',
					requireAuth: true,
				},
			},
			{
				path: '/design',
				name: 'design',
				component: (resolve) =>
					require(['../src/views/mat/design/design.vue'], resolve),
				meta: {
					title: '串珠设计管理',
					requireAuth: true,
				},
			},
		],
	},
	// 标签库路由
	{
		path: '/',
		component: layout,
		meta: {
			title: '素材模块',
		},
		name: 'label',
		redirect: '/label',
		children: [{
			path: '/label',
			name: 'label',
			component: (resolve) =>
				require(['../src/views/labels/label/index.vue'], resolve),
			meta: {
				title: '散素材管理',
				requireAuth: true,
			},
		}, ],
	},
	// 阶段路由
	{
		path: '/',
		component: layout,
		meta: {
			title: '业务模块',
		},
		name: 'business',
		redirect: '/stage',
		children: [{
			path: '/stage',
			name: 'stage',
			component: (resolve) =>
				require(['../src/views/business/stage/index.vue'], resolve),
			meta: {
				title: '业务阶段管理',
				requireAuth: true,
			},
		}, ],
	},
	//话术库管理
	{
		path: '/',
		component: layout,
		meta: {
			title: '话术库',
		},
		name: 'wordlibrary',
		redirect: '/wordmanagement',
		children: [{
			path: '/wordmanagement',
			name: 'wordmanagement',
			component: (resolve) =>
				require([
					'../src/views/wordlibrary/wordmanagement/index.vue',
				], resolve),
			meta: {
				title: '话术库管理',
				requireAuth: true,
			},
		}, ],
	},
	//社区管理模块
	{
		path: '/',
		component: layout,
		meta: {
			title: '社区管理',
		},
		name: 'community',
		redirect: '/announcement',
		children: [{
				path: '/announcement',
				name: 'announcement',
				component: (resolve) =>
					require(['../src/views/community/announcement/index.vue'], resolve),
				meta: {
					title: '公告管理',
					requireAuth: true,
				},
			},
			{
				path: '/plan',
				name: 'announcement',
				component: (resolve) =>
					require(['../src/views/community/plan/index.vue'], resolve),
				meta: {
					title: '销售计划',
					requireAuth: true,
				},
			},
			{
				path: '/privateStory',
				name: 'announcement',
				component: (resolve) =>
					require(['../src/views/community/privateStory/index.vue'], resolve),
				meta: {
					title: '私定故事',
					requireAuth: true,
				},
			},
		],
	},
	//系统管理
	{
		path: '/',
		component: layout,
		meta: {
			title: '系统管理',
		},
		name: 'system ',
		redirect: '/menuSettting',
		children: [{
				path: '/menusettting',
				name: 'menusettting',
				component: (resolve) =>
					require(['../src/views/system/menuSettting/index.vue'], resolve),
				meta: {
					title: '菜单管理',
					requireAuth: true,
				},
			},
			{
				path: '/roles',
				name: 'roles',
				component: (resolve) =>
					require(['../src/views/system/roles/index.vue'], resolve),
				meta: {
					title: '角色权限',
					requireAuth: true,
				},
			},
			{
				path: '/usersetting',
				name: 'usersetting',
				component: (resolve) =>
					require(['../src/views/system/userSetting/index.vue'], resolve),
				meta: {
					title: '用户管理',
					requireAuth: true,
				},
			},
		],
	},
	//销售计划管理
	{
		path: '/',
		component: layout,
		meta: {
			title: '销售计划管理',
		},
		name: 'salePlanManage',
		redirect: '/custom',
		children: [{
				path: '/custom',
				name: 'custom',
				component: (resolve) =>
					require(['../src/views/salePlanManage/custom/index.vue'], resolve),
				meta: {
					title: '自定义字段',
					requireAuth: true,
				},
			},

			{
				path: '/planlist',
				name: 'planlist',
				component: (resolve) =>
					require(['../src/views/community/planlist/index.vue'], resolve),
				meta: {
					title: '计划列表',
					requireAuth: true,
				},
			},
			{
				path: '/salesPlan',
				name: 'salesPlan',
				component: (resolve) =>
					require(['../src/views/community/planlist/SalesPlan.vue'], resolve),
				meta: {
					title: '计划管理',
					requireAuth: true,
				},
			},
		],
	},
	{
		path: '/',
		component: layout,
		meta: {
			title: '会员管理',
		},
		name: 'memberManagement',
		redirect: '/memberManagement',
		children: [{
				path: '/ripening',
				name: 'ripening',
				component: (resolve) =>
					require([
						'../src/views/memberManagement/ripening/index.vue',
					], resolve),
				meta: {
					title: '养熟体系',
					requireAuth: true,
				},
			},

			{
				path: '/member',
				name: 'member',
				component: (resolve) =>
					require(['../src/views/memberManagement/member/index.vue'], resolve),
				meta: {
					title: '会员管理',
					requireAuth: true,
				},
			},
		],
	},
];

const router = new VueRouter({
	routes,
});

// // 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};
export default router;
